import React, { useState } from 'react';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useIntl } from 'react-intl';
import { getI18n } from '../../utils/intl';
import { object, shape, bool } from 'prop-types';

export const EulaDialog = (props) => {
  const {
    classes,
    eulaProductsMap,
    eulaDetailsMap,
    showCount = true,
  } = props;

  const { getI18nMessage } = getI18n(useIntl());

  const [expandedEulaPanel, setExpandedEulaPanel] = useState("first");
  const handleExpandEulaPanel = eulaUuid => (event, expanded) =>
    setExpandedEulaPanel(expanded ? eulaUuid : false);
  return(
    <>
      {eulaProductsMap &&
        eulaDetailsMap &&
        Object.keys(eulaProductsMap).map((eula, index) => ( eulaDetailsMap[eula] &&
        <ExpansionPanel
          expanded={expandedEulaPanel === eula || (index === 0 && expandedEulaPanel === 'first')}
          className={classes.productGroupPanel}
          key={eula}
          onChange={handleExpandEulaPanel(eula)}
          >
          <ExpansionPanelSummary
            aria-controls="panel1a-content"
            expandIcon={<ExpandMoreIcon />}
            id="panel1a-header"
          >
            <span
              className={classes.heading}
              data-apim-test={`eula-heading-${index}`}
            >
              <span className={classes.accordionTitleBold}>
                {showCount
                  ? getI18nMessage('label.application.details.apis.eulas.accordion.title',
              { index: index+1, count: Object.keys(eulaProductsMap).length })
                  : getI18nMessage('label.application.details.apis.eulas.accordion.title.no.count')}
              </span>
              <span className={classes.accordionTitle}>{eulaProductsMap[eula] && eulaProductsMap[eula].map(product => product.productName).join(', ')}</span>
            </span>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <span
              data-apim-test={`eula-details-${index}`}
              className={classes.panelContent}
              dangerouslySetInnerHTML={{ __html: (eulaDetailsMap[eula].content) }}
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        ))}
    </>
  );
};

EulaDialog.propTypes = {
  classes: shape({}),
  eulaProductsMap: object,
  eulaDetailsMap: object,
  showCount: bool,
}

export default withStyles(styles)(EulaDialog);
